import axios from '@shared/axios-shared';

const getConversations = (student_name, student_status, room_id, page) => {
	return axios.get(
		`/api/v1/conversations?student_name=${student_name}&student_status=${student_status}&room=${room_id}&page=${page}`
	);
};
const getConversationsByStudentName = (student_name) => {
	return axios.get(`/api/v1/conversations?student_name=${student_name}`);
};

const getConversationsDashboard = () => {
	return axios.get(`/api/v1/conversations?&page=1`);
};

const delConversation = (id) => {
	return axios.delete(`/api/v1/conversations/${id}`);
};

const getChannels = () => {
	return axios.get(`/api/v2/chat/channels`);
};

const createChannel = (recipients) => {
	return axios.post(`/api/v2/chat/channels`, { recipients });
};

const sendMessage = (data) => {
	return axios.post(`/api/v2/chat/message`, data);
};

const sendMessageToEntireRoom = (data) => {
	return axios.post(`/api/v2/messaging/room`, data);
};

export {
	getConversations,
	getConversationsDashboard,
	delConversation,
	getConversationsByStudentName,
	createChannel,
	getChannels,
	sendMessage,
	sendMessageToEntireRoom,
};
